import routerOptions0 from "/workspace/node_modules/.pnpm/nuxt@3.11.2_@parcel+watcher@2.4.1_@types+node@20.11.19_@unocss+reset@0.60.3_encoding@0.1.13_e_pt6mcsv5xdz3ixglsdisjmax5e/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}